import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e05c6560"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Environmental", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Social", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Governance", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "noDataText"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerRowText" }, "Indicator", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerRowText" }, "Ranking", -1))
const _hoisted_10 = { class: "tooltipText" }
const _hoisted_11 = { class: "infoScoreGrey" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sourcesText" }, "Sources: Atradius, Macrobond, European Commission INFORM, Fund for Peace, Transparency International, United Nations Development Programme, World Bank - World Governance Indicators (WGI).", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_name_bar = _resolveComponent("country-name-bar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "esgContainer" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "bodyDivider" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6",
            class: "pl-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "countryNameBar__holder pb-5 pl-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_country_name_bar, {
                        countryName: _ctx.country.country_name
                      }, null, 8, ["countryName"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "accordionRow ma-0 pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pl-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["mb-6 figureTitle", { active: _ctx.esgMode === 'e' }]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changedESGMood('e')))
                      }, _hoisted_2, 2),
                      _createElementVNode("div", {
                        class: _normalizeClass([{ active: _ctx.esgMode === 's' }, "mb-6 figureTitle"]),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changedESGMood('s')))
                      }, _hoisted_4, 2),
                      _createElementVNode("div", {
                        class: _normalizeClass([{ active: _ctx.esgMode === 'g' }, "mb-6 figureTitle"]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changedESGMood('g')))
                      }, _hoisted_6, 2)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            md: "6",
            cols: "12",
            class: "pa-0 ma-0",
            style: {"overflow-y":"auto","padding-bottom":"120px !important"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "esgMobileMenu" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tabs, {
                        "v-model": _ctx.esgMode,
                        "slider-color": "#DC0028",
                        class: "esgTabsMobile",
                        "show-arrows": false
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.esgTitleList, (esgItem) => {
                            return (_openBlock(), _createBlock(_component_v_tab, {
                              key: esgItem.code,
                              onClick: ($event: any) => (_ctx.changedESGMood(esgItem.code))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(esgItem.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["v-model"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.esgMode=='e')
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    class: "mobileText pa-0 ma-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.esgMode=='s')
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    class: "mobileText pa-0 ma-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.esgMode=='g')
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 2,
                    class: "mobileText pa-0 ma-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      (_ctx.dataTableContent.length === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "No data available"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.dataTableContent.length>0)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 3,
                    class: "pa-0 ma-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, { class: "dataHolder" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { class: "dataHeader dataRow" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                md: "9",
                                cols: "8",
                                class: "leftColumn"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                md: "3",
                                cols: "4",
                                class: "rightColumn"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_9,
                                  (!_ctx.isMobile)
                                    ? (_openBlock(), _createBlock(_component_v_tooltip, { key: 0 }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_img, _mergeProps(props, {
                                            src: require('@/assets/icons/atradius-info.svg'),
                                            class: "info-icon"
                                          }), null, 16, ["src"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.rankingTooltip), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.isMobile)
                                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                        key: 1,
                                        "open-on-click": "",
                                        width: "90%",
                                        class: "lineItem movementInfoIcon"
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_img, _mergeProps(props, {
                                            src: require('@/assets/icons/atradius-info.svg'),
                                            class: "info-icon"
                                          }), null, 16, ["src"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.rankingTooltip), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTableContent, (item) => {
                            return (_openBlock(), _createBlock(_component_v_row, {
                              class: "dataInfo dataRow",
                              key: item.key
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  md: "9",
                                  cols: "8",
                                  class: "leftColumn"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "9" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(item.description), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, { cols: "3" }, {
                                          default: _withCtx(() => [
                                            (!_ctx.isMobile)
                                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                  key: 0,
                                                  "open-on-click": "",
                                                  width: "90%",
                                                  text: item.tooltip,
                                                  class: "lineItem movementInfoIcon tooltipText"
                                                }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_img, _mergeProps({ ref_for: true }, props, {
                                                      src: require('@/assets/icons/atradius-info.svg'),
                                                      class: "info-icon"
                                                    }), null, 16, ["src"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["text"]))
                                              : _createCommentVNode("", true),
                                            (_ctx.isMobile)
                                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                  key: 1,
                                                  "open-on-click": "",
                                                  width: "90%",
                                                  class: "lineItem movementInfoIcon"
                                                }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_img, _mergeProps({ ref_for: true }, props, {
                                                      src: require('@/assets/icons/atradius-info.svg'),
                                                      class: "info-icon"
                                                    }), null, 16, ["src"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.tooltip), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, {
                                  md: "3",
                                  cols: "4",
                                  class: "rightColumn"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(item.value), 1),
                                    _createElementVNode("span", _hoisted_11, "/" + _toDisplayString(item.count), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}